import accessGroupsSlice from './accessGroups/accessGroupsSlice';
import auditSlice from './audit/auditSlice';
import cardsSlice from './cards/cardsSlice';
import cardtimesSlice from './cardtimes/cardtimesSlice';
import type { PageNameType } from './clientConfiguration/clientConfigurationSlice';
import contractsSlice from './contracts/contractsSlice';
import contractsDetailsSlice from './contractsDetails/contractsDetailsSlice';
import customersSlice from './customers/customersSlice';
import destPointSlice from './destPoint/destPointSlice';
import destPointDetailsSlice from './destPointDetails/destPointDetailsSlice';
import driversSlice from './drivers/driversSlice';
import dynamicTablesSlice from './dynamicTables/dynamicTablesSlice';
import identitySlice from './identity/identitySlice';
import inventorizationSlice from './inventorization/inventorizationSlice';
import iotSlice from './iot/iotSlice';
import licensesSlice from './licenses/licensesSlice';
import ordersSlice from './orders/ordersSlice';
import { getBaseDomain } from './pageDomain';
import productsSlice from './products/productsSlice';
import productsGroupsSlice from './productsGroups/productsGroupsSlice';
import requestedMsgSlice from './requestedMsg/requestedMsgSlice';
import resultsSlice from './results/resultsSlice';
import settingsSlice from './settings/settingsSlice';
import spySlice from './spy/spySlice';
import taskSchedulerSlice from './taskScheduler/taskSchedulerSlice';
import usersSlice from './users/usersSlice';
import vehiclesSlice from './vehicles/vehiclesSlice';
import warehouseSlice from './warehouse/warehouseSlice';
import weightingsSlice from './weightings/weightingsSlice';

const reduxSlicesList = {
	results: resultsSlice.actions,
	customers: customersSlice.actions,
	orders: ordersSlice.actions,
	drivers: driversSlice.actions,
	vehicles: vehiclesSlice.actions,
	weightings: weightingsSlice.actions,
	products: productsSlice.actions,
	'products/groups': productsGroupsSlice.actions,
	contracts: contractsSlice.actions,
	'contracts/details': contractsDetailsSlice.actions,
	spy: spySlice.actions,
	destPoint: destPointSlice.actions,
	'destPoint/details': destPointDetailsSlice.actions,
	cards: cardsSlice.actions,
	'cards/cardtimes': cardtimesSlice.actions,
	settings: settingsSlice.actions,
	identity: identitySlice.actions,
	licenses: licensesSlice.actions,
	users: usersSlice.actions,
	accessGroups: accessGroupsSlice.actions,
	audit: auditSlice.actions,
	warehouse: warehouseSlice.actions,
	inventorization: inventorizationSlice.actions,
	IoT: iotSlice.actions,
	dynamicTables: dynamicTablesSlice.actions,
	taskScheduler: taskSchedulerSlice.actions,
	requestedMsg: requestedMsgSlice.actions,
};

// Runtime table names (`dynamicTables/{TableName}`) have no per-table entry —
// fall back to the base-domain slice. A raw hit always wins, so static names
// keep resolving exactly as before.
export const resolveSliceActions = (table: string) =>
	reduxSlicesList[table as keyof typeof reduxSlicesList] ??
	reduxSlicesList[
		getBaseDomain(table as PageNameType) as keyof typeof reduxSlicesList
	];

export default reduxSlicesList;
